// TintiCloud — Projetos. Dados de demonstração.
export const projects = [
  {
    id: "cjudi", name: "CJUDI", client: "CJUDI", clientId: "cjudi", status: "healthy", server: "sv1",
    stack: "React · FastAPI · MongoDB", env: "production", framework: "Docker Compose",
    domains: ["cjudi.com", "www.cjudi.com"],
    services: ["cjudi-frontend", "cjudi-backend", "cjudi-celery", "cjudi-mongo"],
    lastDeploy: "20/09/2026 09:18", branch: "main", commit: "a1b2c3d",
  },
  {
    id: "smartfolks", name: "Smartfolks", client: "Smartfolks", clientId: "smartfolks", status: "healthy", server: "sv2",
    stack: "WordPress · MySQL", env: "production", framework: "WordPress",
    domains: ["smartfolks.com.br"], services: ["smartfolks-wordpress", "smartfolks-mysql"],
    lastDeploy: "19/09/2026 18:11", branch: "main", commit: "e4f5a6b",
  },
  {
    id: "moracomigo", name: "MoraComigo", client: "MoraComigo", clientId: "moracomigo", status: "warning", server: "sv1",
    stack: "Next.js · Node · Postgres", env: "production", framework: "Node.js",
    domains: ["moracomigo.com.br"], services: ["moracomigo-api", "moracomigo-web"],
    lastDeploy: "19/09/2026 22:34", branch: "main", commit: "77aa12c",
  },
  {
    id: "tintitech", name: "TintiTech", client: "TintiTech", clientId: "tintitech", status: "healthy", server: "sv2",
    stack: "Astro · Node", env: "production", framework: "Astro",
    domains: ["tintitech.com.br", "api.tintitech.com.br"], services: ["tintitech-web", "tintitech-api"],
    lastDeploy: "18/09/2026 14:02", branch: "main", commit: "5b8e0f1",
  },
  {
    id: "c2desk", name: "C2Desk", client: "C2Desk", clientId: "c2desk", status: "healthy", server: "sv1",
    stack: "React · Django", env: "production", framework: "Django",
    domains: ["c2desk.com.br"], services: ["c2desk-web", "c2desk-worker"],
    lastDeploy: "19/09/2026 16:05", branch: "main", commit: "9c0d3e2",
  },
  {
    id: "primeagents", name: "PrimeAgents", client: "Prime Encontros", clientId: "prime", status: "error", server: "sv4",
    stack: "Node · Redis", env: "staging", framework: "Node.js",
    domains: ["api.primeencontros.com", "primeencontros.com"], services: ["primeagents-web"],
    lastDeploy: "17/09/2026 11:40", branch: "develop", commit: "deadbe0",
  },
];

export const projectServices = {
  cjudi: [
    { name: "cjudi-frontend", type: "Web", image: "cjudi/frontend:1.8.2", status: "running", cpu: 4.2, mem: "128 MB", replicas: "2/2" },
    { name: "cjudi-backend", type: "API", image: "cjudi/backend:2.1.0", status: "running", cpu: 11.5, mem: "340 MB", replicas: "2/2" },
    { name: "cjudi-celery", type: "Worker", image: "cjudi/backend:2.1.0", status: "running", cpu: 6.8, mem: "210 MB", replicas: "1/1" },
    { name: "cjudi-mongo", type: "Database", image: "mongo:7.0", status: "running", cpu: 8.1, mem: "890 MB", replicas: "1/1" },
  ],
};
